import ConfirmDialog from './ConfirmDialog.component';

export default ConfirmDialog;
